<template>
    <section id="cards-cta">
        <section class="card" data-aos="fade" data-aos-duration="1200">
            <div class="icon-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-brand-torchain"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M15.588 15.537l-3.553 -3.537l-7.742 8.18c-.791 .85 .153 2.18 1.238 1.73l9.616 -4.096a1.398 1.398 0 0 0 .44 -2.277" /><path d="M8.412 8.464l3.553 3.536l7.742 -8.18c.791 -.85 -.153 -2.18 -1.238 -1.73l-9.616 4.098a1.398 1.398 0 0 0 -.44 2.277l-.001 -.001" /></svg>
            </div>
            
            <div class="textos-cards">
                <h3 class="titulo-cards">Agilidade</h3>
                <p class="descricao-cards">Agendamos seu serviço de forma prática e buscamos oferecer um atendimento ágil, do orçamento à higienização.</p>
            </div>
        </section>

        <section class="card" data-aos="fade" data-aos-delay="200" data-aos-duration="1200">
            <div class="icon-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-stars"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M17.8 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138" /><path d="M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138" /><path d="M12 9.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138" /></svg>
            </div>
            
            <div class="textos-cards">
                <h3 class="titulo-cards">Qualidade</h3>
                <p class="descricao-cards">Utilizamos técnicas e produtos adequados para entregar uma higienização eficiente e um resultado de qualidade.</p>
            </div>
        </section>

        <section class="card" data-aos="fade" data-aos-delay="300" data-aos-duration="1200">
            <div class="icon-card">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-users"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" /></svg>
            </div>
            
            <div class="textos-cards">
                <h3 class="titulo-cards">Confiança</h3>
                <p class="descricao-cards">Trabalhamos com responsabilidade, atenção e compromisso para cuidar dos seus estofados como eles merecem.</p>
            </div>
        </section>
    </section>

</template>

<script>
export default{
    name: 'CardsCTALandingPage'
}
</script>


<style scoped>
#cards-cta{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    max-width: 1200px;
    margin: 0 auto;
    gap: 38px;
    padding: 42px 0;
    box-sizing: border-box;
}

.card{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
}

.icon-card{
    width: 60px;
    height: 60px;
    color: var(--cor-tema);
    filter: drop-shadow(0 0 12px #0f0f541c);
}

.textos-cards{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.titulo-cards{
    text-align: center;
    font-size: 20px;
}

.descricao-cards{
    text-align: center;
    font-size: 16px;
    font-weight: 300;
}

@media (min-width: 768px) and (max-width: 1200px){
    #cards-cta{
        padding: 42px 24px;
    }
}

@media (max-width: 600px) {
    #cards-cta{
        padding: 42px 24px;
    }

    #cards-cta{
        grid-template-columns: 1fr;
    }

    .titulo-cards{
        font-size: 18px;
    }

    .descricao-cards{
        font-size: 14px;
    }
}
</style>